export default __webpack_public_path__ + "static/video1-121e2620fb3c225f9699d46e6a3608d3.mp4";